import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";
import { deleteQuestionBankQuestion } from ".";

export function useDeleteBankQuestion(){
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.question_bank._def,
        mutationFn: deleteQuestionBankQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question_bank._def, exact: false });
        }
    })
}